import useAuthToken from '../storage/token/hook';
export default function useIsSuperAdmin() {
    const [, , authTokenHelpers] = useAuthToken();
    const isSuperAdmin = authTokenHelpers.getIsSuperAdmin();
    return isSuperAdmin;
}
